// extracted by mini-css-extract-plugin
module.exports = {"mod1":"Table_mod1__3RTP3","rightCell":"Table_rightCell__nFV6j","thead":"Table_thead__2KvId"};